<div class="flex flex-col p-5 w-full">
    <div class="flex justify-between pb-4 items-center">
        <div class="pl-2 header-title">Credentials</div>
    </div>

    @if (credentialItems$ | async; as items) {
        <div class="flex flex-col gap-4">
            @for (item of items; track item) {
                <div class="bg-white rounded-xl shadow-md p-5">
                    <div class="text-sm font-semibold text-dark-500 uppercase tracking-wide mb-3">{{ item.label }}</div>
                    @if (item.value) {
                        <div class="flex items-center gap-2">
                            <span class="font-mono text-sm break-all flex-1">
                                {{ isVisible(item.key) ? item.value : '••••••••••••••••••••••••' }}
                            </span>
                            <button mat-icon-button (click)="toggleVisibility(item.key)" [matTooltip]="isVisible(item.key) ? 'Hide' : 'Show'">
                                <mat-icon>{{ isVisible(item.key) ? 'visibility_off' : 'visibility' }}</mat-icon>
                            </button>
                            <button mat-icon-button (click)="copyToClipboard(item.value)" matTooltip="Copy to clipboard">
                                <mat-icon>content_copy</mat-icon>
                            </button>
                        </div>
                    } @else {
                        <span class="text-dark-400 text-sm italic">Not configured</span>
                    }
                </div>
            }
        </div>
    } @else {
        <div class="w-full flex items-center justify-center p-8">
            <mat-spinner [diameter]="40"></mat-spinner>
        </div>
    }
</div>
